<template>
    <div>
		<el-tabs v-model="activeName" type="card">
			<el-tab-pane :label="this.$t('sensorsmanage.title')" name="first"><SensorBaseInfo></SensorBaseInfo></el-tab-pane>
		</el-tabs>
    </div>
</template>

<script>
	// import SensorData from '../../components/pages/sensorManage/SensorData.vue';
	import SensorBaseInfo from '../../components/pages/sensorManage/SensorBaseInfo.vue';
    export default {
        name: "Admin",
		components:{
			// SensorData,
			SensorBaseInfo
		},
        data() {
            return {
				activeName: 'first'
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style scoped>
    
</style>
